import styleText from './as-panel-header.css?raw';

export class AsPanelHeader extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = /*html*/`
      <div class="panel-header">
        <slot></slot>
      </div>
    `;
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsPanelHeader.sheet
    ];
  } 
  connectedCallback() {
    
  }
}

customElements.define('as-panel-header', AsPanelHeader);  
